import { Observable } from 'rxjs';
import Rxios from '../vendor/rxios';
import { getDataProperty, queryParams } from './utils';

export default class ApiService {
    private http: Rxios;
    private formAntiForgeryToken: string;
    private sitecoreId: string;
    private sitecoreLang: string;
    private source: string;

    // Query parameters
    private page: number;
    private pageSize: number;

    constructor() {
        this.formAntiForgeryToken = getDataProperty('data-antiforgery-token');
        this.sitecoreId = getDataProperty('data-id');
        this.sitecoreLang = getDataProperty('data-lang');
        this.page = Number(queryParams.page);
        this.pageSize = Number(queryParams.pageSize);
        this.source = getDataProperty('data-source').replace(/"/g, '');
        if (!this.source) {
            this.source = 'dynamiclists';
        }

        this.http = new Rxios({
            baseURL: process.env.VUE_APP_API_ENDPOINT,
            headers: {
                'RequestVerificationToken': this.formAntiForgeryToken,
                'SitecoreId': this.sitecoreId,
                'SitecoreLanguage': this.sitecoreLang,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
    }

    public get<T>(action: string, queryParams?: object): Observable<T> {
        return this.http.get<T>(`/${this.source}/${action}`, queryParams);
    }

    public post<T>(
        action: string,
        body: object,
        queryParams?: object,
    ): Observable<T> {
        return this.http.post<T>(`/${this.source}/${action}`, body, queryParams);
    }

    public patch<T>(
        url: string,
        body: object,
        queryParams?: object,
    ): Observable<T> {
        return this.http.patch<T>(url, body, queryParams);
    }

    public delete<T>(url: string, queryParams?: object): Observable<T> {
        return this.http.delete<T>(url, queryParams);
    }
}
